import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { AttributionScopedItem } from '../common/attributionScope/AttributionScopedItem'

import { Definition, Term } from '../common/Details'
import { Box, Icon, ListGrid, Button, ListGridItem } from '@maui/elements'
import { InfoTooltip } from '../common/Tooltip'

const noDataAvailable = 'No data available'

export function ActorHistoryDetailsView({ list, term, tooltip, mergedUnc }) {
  const [showMore, setShowMore] = useState(false)
  return (
    <>
      <Term display='inline-flex'>
        <Box color='colorTextDeemphasis' width='51px' flexBasis='min-content'>{term}</Box>
        <InfoTooltip tooltip={tooltip} ml='spaceGapLarge' />
      </Term>
      <Definition>
        {list?.length > 0
          ? (
            <>
              <ListGrid list={showMore || list.length < 6 ? list : list.slice(0, 6)} cellWidth={['100%', '50%', '16.666667%']}>
                {item => (
                  <AttributionScopedItem itemScope={item.attribution_scope}>
                    <ListGridItem overflow="hidden">
                      <Box
                        bg={mergedUnc && mergedUnc.name === item.name ? 'colorBackgroundOverlay' : undefined}
                        p={mergedUnc && 'spacePaddingTiny'}
                        display='inline-flex'
                        alignItems='center'
                        overflow='hidden'
                        title={item.name}
                      >
                        <Icon name='user-secret' mr="spaceGapTiny" />
                        <Box
                          textStyles='body1'
                          overflow='hidden'
                          whiteSpace='nowrap'
                          textOverflow='ellipsis'
                          color='colorTextMain'
                        >
                          {item.name}
                        </Box>
                      </Box>
                    </ListGridItem>
                  </AttributionScopedItem>
                )}
              </ListGrid>
              {list.length > 6 && <Button onClick={() => setShowMore(!showMore)} variant="text" p="0">{!showMore ? 'Show More' : 'Show Less'}</Button>}
            </>
            )
          : noDataAvailable
        }
      </Definition>
    </>
  )
}

ActorHistoryDetailsView.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.node,
  })),
  term: PropTypes.node,
  tooltip: PropTypes.string,
}

export default ActorHistoryDetailsView
